<!--
 * @Author: guoyu
 * @Date: 2020-05-08 14:54:16
 * @LastEditors: your name
 * @LastEditTime: 2020-09-24 12:41:18
 * @Description: 订单的信息（订单类型，数目，以及一些描述）
 -->
<template>
  <div class="order-info">
    <div class="order-avatar">
      <img :src="orderInfo.avatarImageUrl" alt="player-avatar" />
    </div>
    <div class="order-info-text">
      <p class="text-line1">
        <span class="user-name">{{ orderInfo.nickname || '...' }}</span>
        <!-- 新ui中不再展示，暂时保留以备调整-->
        <!-- <span>${{ payNum }}</span> -->
      </p>
      <p class="text-line2">{{ orderInfo.gameName || '...' }}</p>
      <p class="text-line3">
        {{ salesPrice || 0}}<span>幣/{{ salesUnit | salesUnitTranslate }}</span>
      </p>
      <input-number
        class="order-num"
        v-model="orderInfo.count"
        :max="15"
        :disabled="isFromNew || !!$route.query.orderNo || !!quickMatchCount"
        @change="change"
      ></input-number>
    </div>
  </div>
</template>
<script>
import InputNumber from '@/components/common/input/input-number';
export default {
  name: 'OrderInfo',
  components: { InputNumber },
  model: {
    event: 'change',
    prop: 'orderInfo'
  },
  props: {
    orderInfo: {
      default: orderInit
    },
    isFromNew: {
      type: Boolean,
      default: false
    },
    quickMatchCount: {
      type: Number,
      default: 0
    },
    // 计费模式决定
    salesPrice: {
      type: [String, Number],
      default: 0,
    },
    salesUnit: {
      type: String,
      default: ''
    }
  },
  computed: {
    payNum() {
      return this.orderInfo.count * this.orderInfo.price || 0;
    }
  },
  methods: {
    change() {
      this.$emit('change', this.orderInfo);
    }
  }
};

/**
 * @description: 初始化默认订单信息属性
 */
function orderInit() {
  return {
    avatarImageUrl: '',
    nickname: '...', // 陪玩玩家名
    gameName: '...', // 游戏名
    salesPrice: 0, // 单价
    count: 0 // 数量
  };
}
</script>
<style lang="scss" scoped>
.order-info {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 16px 18px 20px;
}
.order-avatar {
  position: relative;
  height: 85px;
  width: 85px;
  overflow: hidden;
  border-radius: 4px;
  img {
    // 解决图片加载失败
    position: relative;
    display: block;
    height: 87px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
  }
}
.order-info-text {
  flex-grow: 1;
}
.text-line1 {
  display: flex;
  justify-content: space-between;
  line-height: 1;
  font-size: 14px;
  color: #333333;
  .user-name {
    @include ellipsis;
    font-weight: 500;
    line-height: 1.2;
  }
}
.text-line2 {
  margin: 14px 0 14px;
  line-height: 1;
  font-size: 14px;
  color: #999999;
}
.text-line3 {
  font-size: 16px;
  color: $color-yellow;
  span {
    font-size: 12px;
  }
}
.order-num {
  position: absolute;
  right: 18px;
  bottom: 21px;
}
@media screen and (min-width: 600px) {
  .order-info {
    padding: 30px 0px;
    border-bottom: 2px solid #f4f4f4;
  }
  .order-info-text {
    display: flex;
    height: 85px;
    justify-content: space-between;
    align-items: center;
    margin-left: 16px;
  }
  .order-num {
    position: initial;
    order: 1;
  }
  .text-line1 {
    max-width: 160px;
  }
  .text-line2 {
    max-width: 160px;
    margin: 0;
    color: #333333;
  }
  .text-line3 {
    display: flex;
    align-items: center;
    order: 2;
    margin-right: 54px;
    font-weight: 600;
    font-size: 22px;
    color: #333333;
    span {
      font-size: 16px;
    }
  }
  .player-coin {
    display: inline-block;
    width: 18px;
    height: 24px;
    margin-right: 4px;
    background: url('~@/assets/imgs/player-coin.png') no-repeat center;
    background-size: 18px 18px;
    vertical-align: bottom;
  }
}
</style>
